import { router, remainingPaths } from "@/router";
const shortcuts = () => {
  // 日期组件使用的
  return [
    {
      text: "最近一周",
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      }
    },
    {
      text: "最近一个月",
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      }
    },
    {
      text: "最近三个月",
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      }
    }
  ];
};
// 把链接后面的参数转换为对象格式
const param2Obj = url => {
  const obj = {};
  const searchArr = url.split("&");
  searchArr.forEach(v => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
};
// 复制
const copy = data => {
  let text = data;
  let oInput = document.createElement("input");
  oInput.value = text;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  console.log(oInput.value);
  document.execCommand("Copy"); // 执行浏览器复制命令
  ElMessage.success({
    message: "复制成功",
    type: "success"
  });
  oInput.remove();
};

// 获取最近某天日期--n可为正负数或0, symbol,符号
const getRecentDay = (n, symbol, noTime) => {
  let dd = new Date();
  dd.setDate(dd.getDate() + (n || 0)); //获取n天后的日期
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1; //获取当前月份的日期
  let d = dd.getDate();
  const hour = dd.getHours();
  const minute = dd.getMinutes();
  const second = dd.getSeconds();
  let day =
    y +
    (symbol ? symbol : "") +
    (m < 10 ? "0" + m : m) +
    (symbol ? symbol : "") +
    (d < 10 ? "0" + d : d);
  if (!noTime) {
    // noTime 是否添加时间
    day =
      day +
      " " +
      (hour < 10 ? "0" + hour : hour) +
      ":" +
      (minute < 10 ? "0" + minute : minute) +
      ":" +
      (second < 10 ? "0" + second : second);
  }
  return day;
};

// 根据id，返回模式名称
function editModeName(value) {
  let modeType = JSON.parse(localStorage.getItem("modeType"));
  let str = "";
  modeType.forEach(element => {
    if (element.value == value) {
      str = element.label;
    }
  });
  return str;
}

// 处理日期格式
const editTime = (date, type) => {
  const dt = new Date(date);
  let y = dt.getFullYear();
  let m = dt.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = dt.getDate();
  d = d < 10 ? "0" + d : d;
  let h = dt.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = dt.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  let second = dt.getSeconds();
  second = second < 10 ? "0" + second : second;
  return `${y}${type ? type : "-"}${m}${
    type ? type : "-"
  }${d} ${h}:${minute}:${second}`;
};

/**
 * 将 JS 对象转换为 URL 查询参数字符串（支持空字段过滤）
 * @param {Object} obj 要转换的对象
 * @param {Object} [options] 配置选项
 * @param {boolean} [options.arrayFormat=[]] 数组格式，可选值：'[]'（默认）、'repeat'、'comma'
 * @param {string[]} [options.filterEmptyTypes=['null', 'undefined', 'emptyString', 'emptyArray', 'emptyObject']] 要过滤的空值类型
 * @returns {string} URL 查询参数字符串（不带问号前缀）
 */
function objectToUrlParams(obj, options = {}) {
  // 默认配置（新增空值过滤规则）
  const {
    arrayFormat = "[]",
    filterEmptyTypes = [
      "null", // 过滤 null
      "undefined", // 过滤 undefined
      "emptyString", // 过滤空字符串（含全空格）
      "emptyArray", // 过滤空数组 []
      "emptyObject" // 过滤空对象 {}
    ]
  } = options;

  const params = [];

  // 辅助函数：判断值是否为需要过滤的空值
  function isEmptyValue(value) {
    // null
    if (filterEmptyTypes.includes("null") && value === null) return true;
    // undefined
    if (filterEmptyTypes.includes("undefined") && value === undefined)
      return true;
    // 空字符串（含全空格）
    if (
      filterEmptyTypes.includes("emptyString") &&
      typeof value === "string" &&
      value.trim() === ""
    )
      return true;
    // 空数组
    if (
      filterEmptyTypes.includes("emptyArray") &&
      Array.isArray(value) &&
      value.length === 0
    )
      return true;
    // 空对象（排除数组、null）
    if (
      filterEmptyTypes.includes("emptyObject") &&
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length === 0
    )
      return true;

    return false;
  }

  // 递归处理对象/数组
  function process(value, keyPrefix = "") {
    // 跳过需要过滤的空值
    if (isEmptyValue(value)) return;

    // 处理数组
    if (Array.isArray(value)) {
      switch (arrayFormat) {
        case "repeat":
          value.forEach(item => process(item, keyPrefix));
          break;
        case "comma":
          // 过滤数组中的空元素（保持和顶层一致的过滤规则）
          const validItems = value.filter(item => !isEmptyValue(item));
          if (validItems.length > 0) {
            const commaValue = validItems.map(encodeURIComponent).join(",");
            params.push(`${encodeURIComponent(keyPrefix)}=${commaValue}`);
          }
          break;
        default:
          value.forEach(item => process(item, `${keyPrefix}[]`));
      }
      return;
    }

    // 处理嵌套对象
    if (typeof value === "object" && value !== null) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        const newKey = keyPrefix ? `${keyPrefix}.${subKey}` : subKey;
        process(subValue, newKey);
      });
      return;
    }

    // 处理基本类型（编码后加入参数）
    const encodedKey = encodeURIComponent(keyPrefix);
    const encodedValue = encodeURIComponent(String(value));
    params.push(`${encodedKey}=${encodedValue}`);
  }

  // 开始处理对象
  Object.entries(obj).forEach(([key, value]) => {
    process(value, key);
  });
  return params.join("&");
}

// 2025-11-27T17:06:20.505+08:00   格式转化为   YYYY-MM-DD HH:mm:ss
function formatIsoToDatetime(isoStr) {
  if (!isoStr) {
    return "";
  }
  const date = new Date(isoStr);

  // 提取时间部分（注意：getMonth() 从 0 开始，需 +1）
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零（如 3→03）
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");

  // 拼接目标格式
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

// 秒数转换为hh:mm:ss格式
function secondsToTime(seconds, type) {
  // 确保秒数为非负整数
  seconds = Math.max(0, Math.floor(seconds));

  // 计算小时、分钟和秒
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // 格式化为两位数
  const pad = num => num.toString().padStart(2, "0");
  if (type == "china") {
    return `${pad(hours) * 1}小时${pad(minutes) * 1}分`;
  } else {
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  }
}
// 分钟数转换
function secondsToTime2(seconds, type) {
  // 确保秒数为非负整数
  seconds = Math.max(0, Math.floor(seconds));

  // 计算小时、分钟
  const hours = Math.floor(seconds / 60);
  const minutes = Math.floor(seconds % 60);

  // 格式化为两位数
  const pad = num => num.toString().padStart(2, "0");
  if (type == "分钟") {
    return `${pad(hours) * 1}小时${pad(minutes) * 1}分钟`;
  } else {
    return `${pad(hours) * 1}小时${pad(minutes) * 1}分`;
  }
}
// 去用户详情页
function gotoUserDetail(id) {
  if (!id) {
    return;
  }
  localStorage.setItem(
    "userDetail",
    JSON.stringify({
      math: Date.parse(new Date().toString()),
      type: "check",
      obj: {
        id: id
      }
    })
  );
  router.push({
    path: "/userDetail"
  });
}
// 判断是否全是空格或换行
function isAllSpacesOrNewLines(str) {
  return /^[\s\n]*$/.test(str);
}
// 判断富文本是否全是空格或换行
function isExactlySpecificChars(str) {
  // 获取HTML内容
  const html = str;

  // 移除所有HTML标签
  const text = html.replace(/<[^>]*>/g, "");

  // 解码HTML实体（如 &nbsp;）
  const decoded = document.createElement("textarea");
  decoded.innerHTML = text;
  const plainText = decoded.value;

  // 去除所有空白字符
  return plainText.replace(/\s+/g, "").length == 0;
}
// 上传提示
function uploadMessage(fileSize) {
  let str = Math.ceil(fileSize / 1024 / 500);
  if (str > 3) {
    ElMessage({
      message: `上传预计花费${str}秒`,
      type: "warning"
    });
  }
  console.log("文件大小:", fileSize, "字节, 预计", str, "秒");
}

function handleKeydownFilter(e) {
  // 禁止的按键码
  const blockedKeys = [
    " ", // 空格
    "Enter", // 回车
    // "Tab", // 制表符
  ];

  if (blockedKeys.includes(e.key)) {
    e.preventDefault(); // 阻止默认输入
    return false;
  }

  // 或者用 keyCode（兼容旧浏览器）
  // [32, 13, 9]
  if ([32, 13].includes(e.keyCode)) {
    e.preventDefault();
  }
}
// 导出所有方法
export default {
  shortcuts, // 日期组件使用的
  param2Obj, // 把链接后面的参数转换为对象格式
  getRecentDay, // 获取最近某天日期--n可为正负数或0, symbol,符号
  editTime, // 处理日期格式
  copy, // 复制
  objectToUrlParams, // 将 JS 对象转换为 URL 查询参数字符串（支持空字段过滤）
  formatIsoToDatetime, // 2025-11-27T17:06:20.505+08:00   格式转化为   YYYY-MM-DD HH:mm:ss
  editModeName, // 根据id，返回模式名称
  secondsToTime, // 秒数转换为hh:mm:ss格式
  gotoUserDetail, // 去用户详情页
  isAllSpacesOrNewLines, // 判断是否全是空格或换行
  uploadMessage, // 上传提示
  secondsToTime2, // 分钟数转换
  isExactlySpecificChars, // 判断富文本是否全是空格或换行
  handleKeydownFilter,   // 禁止输入空格
};
